import React from "react";
import works from "../../src/data/works";
import LetsWork from "../components/LetsWorkTogether";

const Works = () => {
  return (
    <>
      <div className="services section-title mt-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-7 mx-auto">
              <div className="services-title mb-5 mt-5">
                <h1 className="title-font title-font-size">Projects</h1>
                <p className="title-text mt-4 mb-4 title-font-2">
                  We helped these companies test their assumptions, prototype
                  their idea, build an MVP with our Design Sprint approach and
                  helped them ship their product to the market.
                </p>
              </div>
            </div>
          </div>
          <div className="row align-items-center works">
            {works.map((works) => (
              <div className="col-lg-6" key={works.id}>
                <h3 className="projects-title">{works.title}</h3>
                <img
                  src={works.src}
                  alt="projects"
                  className="workthumbnail mb-3"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <LetsWork />
    </>
  );
};

export default Works;
